import { apiInstance } from '../config/apiInstance';
import { GET_ELECTRONIC_DOCS } from '../index';

export const getDataRips = async(documentNumberId: string): Promise<any> => {
    const response = await apiInstance.get( `${GET_ELECTRONIC_DOCS}/${documentNumberId}/rips`);
    
    return response.data;
}